<template>
  <div>
    <b-row>
      <b-col md="3" lg="3" xl="3">
        <b-table
            hover
            show-empty
            selectable
            ref="categoryTable"
            select-mode="single"
            head-variant="light"
            class="bg-white"
            sticky-header="500px"
            :busy="categoryLoading"
            :fields="categoryTableDataFields"
            :items="categoryTableData"
            @row-selected="categoryClick"
        >
          <template v-slot:cell(label)="{ item }">
            <div style="cursor:pointer;">
              <b-icon class="mr-1" icon="folder-fill" variant="warning"></b-icon>
              <span>
                  {{item.label?item.label:'--'}}
                </span>
            </div>
          </template>
          <template v-slot:table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:empty="{}">
            <div style="text-align: center;">
              <img src="/image/static/img/nodata.png" />
              <p class="no-data">{{$l('INDEX.tips_no_data')||'暂无数据！'}}</p>
            </div>
          </template>
        </b-table>
      </b-col>
      <b-col md="9" lg="9" xl="9">
        <b-table
            :busy="loading"
            ref="table"
            :fields="tableDataFields"
            :items="tableData"
            head-variant="light"
            hover
            class="bg-white"
            show-empty
            sort-icon-left
        >
          <template v-slot:cell(resInputColumnType)="data">
            <span>{{data.item.resInputColumnType === 'select'?'选项':'文字'}}</span>
          </template>
          <template v-slot:cell(isMultiselect)="data">
            <b-badge
                :variant="data.item.isMultiselect === 'Y'?'success':'danger'"
            >{{data.item.isMultiselect === 'Y'?'是':'否'}}</b-badge>
          </template>
          <template v-slot:cell(isRequired)="data">
            <b-badge
                :variant="data.item.isRequired === 'Y'?'success':'danger'"
            >{{data.item.isRequired === 'Y'?'是':'否'}}</b-badge>
          </template>
          <template v-slot:cell(isVisible)="data">
            <b-badge
                :variant="data.item.isVisible === 'Y'?'success':'danger'"
            >{{data.item.isVisible === 'Y'?'是':'否'}}</b-badge>
          </template>
<!--          <template v-slot:cell(modifyInfo)="data">-->
<!--            <div>-->
<!--              <span>修改人: {{data.item.modifyByName}}</span>-->
<!--              <br />-->
<!--              <span>修改日期: {{data.item.modifyDate}}</span>-->
<!--            </div>-->
<!--          </template>-->
          <template v-slot:cell(operation)="data">
            <b-button-group>
              <b-button
                  class="mr-2"
                  v-b-tooltip.hover
                  :title="$l('tips_view')||'查看'"
                  @click="fromLoad('detail', data.item.resTemplateCode)"
                  variant="outline-secondary"
                  size="sm"
              >
                <b-icon-eye></b-icon-eye>
              </b-button>
              <b-button
                  class="mr-2"
                  v-b-tooltip.hover
                  :title="$l('tips_edit')||'编辑'"
                  @click="fromLoad('edit', data.item.resTemplateCode)"
                  variant="outline-secondary"
                  size="sm"
                  v-if="allow('M')"
              >
                <b-icon-pencil></b-icon-pencil>
              </b-button>
              <b-button
                  v-b-tooltip.hover
                  :title="$l('tips_del')||'删除'"
                  :disabled="data.item.isVisible === 'N'"
                  @click="del([data.item.resTemplateCode], 'N')"
                  variant="outline-secondary"
                  size="sm"
                  v-if="allow('D')"
              >
                <b-icon-trash-fill></b-icon-trash-fill>
              </b-button>
            </b-button-group>
          </template>
          <template v-slot:table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:empty="{}">
            <div style="text-align: center;">
              <img src="/image/static/img/nodata.png" />
              <p class="no-data">{{$l('INDEX.tips_no_data')||'暂无数据！'}}</p>
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <!--编辑弹框-->
    <el-dialog
      ref="formDialog"
      :title="formOption.title"
      :visible.sync="formOption.dialogFormVisible"
      :before-close="cancel"
      :close-on-click-modal="false"
      width="800px"
    >
      <page-detail ref="form" :params="params" @success="saveSuccess"></page-detail>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="small">{{$l('form_button_cancel')||'取 消'}}</el-button>
        <el-button
          type="primary"
          @click="save"
          size="small"
          v-show="formOption.dialogSaveBtnVisible"
        >{{$l('form_button_save')||'保 存'}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      default: () => [],
    },
    loading: {
      default: false,
    },
    categoryTableData: {
        default: () => []
    },
    categoryLoading:{
        default: false
    }
  },
  components: {
    PageDetail: () => import("./components/detail"),
  },
  data() {
    return {
      allChecked: false,
      indeterminate: false,
      selected: [],
      // 表单设置
      formOption: {
        title: "",
        dialogFormVisible: false,
        dialogSaveBtnVisible: true,
      },
      categoryTableDataFields: [ {
          key: "label",
          label: this.$l("table_label_category") || "分类名称",
          tdClass: "align-middle text-left"
      }],
      tableDataFields: [
        {
          key: "resInputColumnDisplay",
          label: this.$l("table_label_column_name") || "字段名称",
          tdClass: "align-middle",
        },
        {
          key: "resInputColumnType",
          label: this.$l("table_label_column_type") || "字段类型",
          tdClass: "align-middle",
        },
        {
          key: "isMultiselect",
          label: this.$l("table_label_is_multiselect") || "是否多选",
          tdClass: "align-middle",
        },
        {
          key: "isRequired",
          label: this.$l("table_label_is_required") || "是否必输",
          tdClass: "align-middle",
        },
        {
          key: "isVisible",
          label: this.$l("table_label_is_visiable") || "是否显示",
          tdClass: "align-middle",
        },
        {
          key: "sortOrder",
          label: this.$l("table_label_sortorder") || "顺序",
          tdClass: "align-middle"
        },
        // {
        //   key: "modifyInfo",
        //   label: this.$l("table_label_modifyInfo") || "修改信息",
        //   tdClass: "align-middle",
        // },
        {
          key: "operation",
          label: this.$l("table_label_operation") || "操作",
          tdClass: "align-middle",
        },
      ],
      params:{
        masterCategoryCode: ''
      }
    };
  },
  methods: {
    categoryClick(val){
        if(val[0]) {
            this.params = {
                masterCategoryCode: val[0].value
            }
        }else {
            this.params = {
                masterCategoryCode: ''
            }
        }
        this.$emit('categoryClick',this.params)
    },
    // 加载表单
    fromLoad(ref, val = "") {
      const opt = {
        add: "新增",
        edit: "编辑",
        detail: "详情",
      };
      let key;
      if (ref === "add") {
        if(!this.params.masterCategoryCode){
            this.$message.warning(this.$l('tips_select_category')||'请选择左侧分类!')
            return
        }
        key = "tips_add";
      } else if (ref === "edit") {
        key = "tips_edit";
      } else if (ref === "detail") {
        key = "tips_view";
      }
      // 设置标题
      this.formOption.title = this.$l(key) || opt[ref];
      // 控制保存按钮显隐
      if (ref === "detail") {
        this.formOption.dialogSaveBtnVisible = false;
      } else {
        this.formOption.dialogSaveBtnVisible = true;
      }
      // 显示表单
      this.formOption.dialogFormVisible = true;
      setTimeout(() => {
        // 调用组件表单加载方法
        this.$refs.form.fromLoad(ref, val);
      }, 0);
    },
    clearSelected() {
        this.$refs.categoryTable.clearSelected()
    },
    delRows() {
      let selection = this.selected;
      if (!selection || selection.length < 1) {
        this.$message({
          showClose: true,
          message:
            this.$l("INDEX.tips_question_del_rows") || "请选择需要删除的数据",
          type: "warning",
        });
        return;
      }
      let tempArray = [];
      selection.forEach((item) => {
        tempArray.push(item.resTemplateCode);
      });
      this.del(tempArray);
    },
    del(resTemplateCodeList) {
      this.$confirm(
        this.$l("INDEX.tips_question_delete") || "是否删除？",
        this.$l("INDEX.tips_question_title") || "提示",
        {
          confirmButtonText: this.$l("INDEX.tips_confirm") || "确定",
          cancelButtonText: this.$l("INDEX.tips_cancel") || "取消",
          type: "warning",
        }
      ).then(() => {
        this.$api
          .delResearchInputTemplateApi({ resTemplateCodeList })
          .then(() => {
            this.$message({
              showClose: true,
              message: this.$l("INDEX.tips_delete_ok") || "删除成功！",
              type: "success",
            });
            this.$emit("submit");
          });
      });
    },
    save() {
      this.$refs.form.save();
    },
    saveSuccess() {
      this.cancel();
      this.$emit("submit");
    },
    cancel() {
      this.formOption.dialogFormVisible = false;
    },
    onRowSelected(items) {
      this.selected = items;
      if (items.length === 0) {
        this.indeterminate = false;
        this.allChecked = false;
      } else if (items.length === this.tableData.length) {
        this.indeterminate = false;
        this.allChecked = true;
      } else {
        this.indeterminate = true;
        this.allChecked = false;
      }
    },
    // 选中单行
    selectRow(index) {
      let isRowSelected = this.$refs.table.isRowSelected(index);
      if (isRowSelected) {
        this.$refs.table.unselectRow(index);
      } else {
        this.$refs.table.selectRow(index);
      }
    },
    // 表格全选/取消全选
    selectAllRows() {
      if (!this.allChecked) {
        this.$refs.table.selectAllRows();
      } else {
        this.$refs.table.clearSelected();
      }
    },
  },
};
</script>
